<template>
  <div>
    <nav class="navbar navbar-expand-lg navbar-light bg-light">
      <router-link class="nav-link" to="/puzzles">
       <img :src="require('@/assets/baseballcap_left.png')" />
        YouWillConform
       <img class="flipped" :src="require('@/assets/baseballcap_left.png')" />
      </router-link>
      <!-- <router-link class="nav-link" to="/puzzles/dinnerparty">DinnerParty</router-link> --> 
    </nav>
    <router-view></router-view>
  </div>
</template>

<script>
export default {
  name: "Puzzles",
  components: {}
};
</script>
<style scoped>
img {
  width: 35px;
  height: 27px;
}
/* TODO use shared place */
img.flipped {
  -webkit-transform: scaleX(-1);
  transform: scaleX(-1);
}
a {
  color: #212529;
}
a:hover {
  color: black;
}
a.active {
  color: black;
}
.nav-link:hover {
 -webkit-text-stroke-width: 0.8px;
 -webkit-text-stroke-color: #333B3F;
}
</style>
